import {GenState} from '../../generated/serverModels/GenState';

export class Territory extends GenState {
  constructor(state?: Territory ) {
    super(state);
  }
}
